import {useMutation} from "@tanstack/react-query";

import {useInvalidate} from "@/src/modules/core/hooks";
import {errorHandler} from "@/src/modules/core/lib";
import {captureDomainSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {safelistingsService} from "../services";

export default function useUpdateSafelisting() {
  const invalidateSafelistings = useInvalidate("safelistings");

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: Parameters<typeof safelistingsService.updateSafelisting>[1];
    }) => safelistingsService.updateSafelisting(id, data),
    onSuccess: () => {
      invalidateSafelistings();
    },
    onError: (error) => {
      captureDomainSubmitError(error, {feature: "safelistings", operation: "safelisting_update"});
      errorHandler(error);
    },
  });
}
